import { State } from 'src/types'
import { thumbHook } from 'src/features/brands/treasure/canvas/catchermitt/back/thumbHook'
import { littleHook } from 'src/features/brands/treasure/canvas/catchermitt/back/littleHook'
import { laceDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/lace'
import { liningDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/liningDrawer'
import { backStyleDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/backStyleDrawer'
import { brandLabelDrawerForCatcherMitt } from 'src/features/brands/treasure/canvas/common/useCanvasHelper'
import { canvasResetter } from 'src/features/brands/treasure/canvas/common/canvasResetter'
import { catchFaceDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/catchFaceDrawer'
import { webDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/webDrawer'
import { fingerEmbroideryDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/fingerEmbroideryDrawer'
import { fingerGuardDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/fingerGuardDrawer'

export const treasureCanvasCatcherMittBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  // リセット
  canvasResetter(ctx)

  // 裏革
  liningDrawer(ctx, state)

  // バックスタイル
  backStyleDrawer(ctx, state)

  // 捕球面側
  catchFaceDrawer(ctx, state.catchFace.color, state.stitch.color)

  // 指カバー・指当て
  fingerGuardDrawer(ctx, state)

  // 親指、小指の刺繍
  fingerEmbroideryDrawer(ctx, state.embroideries)

  // ウェブ
  webDrawer(ctx, state)

  // 革紐
  laceDrawer(ctx, state.lace.color)

  // かけ紐
  thumbHook(ctx, state.thumbHook.color)
  littleHook(ctx, state.littleHook.color)

  // ブランドのラベル
  brandLabelDrawerForCatcherMitt(ctx, state, 'treasure')
}
